import React, { useEffect, useRef, useState } from "react";
import styles from "./style.module.css";
import { images } from "../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import Button from "../Button";
import DownloadButton from "../DownloadButton";

const Navbar = () => {
  const navigate = useNavigate();
  const linkRef = useRef([]);
  useEffect(() => {
    linkRef.current
      .filter(
        (elem) =>
          elem.innerText.toLowerCase() ===
          window.location.pathname.split("/")[1].toLowerCase()
      )
      .map((elem) => (elem.style.color = "#192bc2"));
  }, []);

  const activeLink = (e, path) => {
    // navigate(`${path}`);
    linkRef.current.map((elem) => (elem.style.color = "black"));
    e.target.style.color = "#192bc2";
  };
  const navItemContainer = useRef(null);

  const [openPopUp, setOpenPopUp] = useState(false);
  const toggelPopUp = (e) => {
    navItemContainer.current.style.height = "0";
    navItemContainer.current.style.width = "0";
    const popUpContainer = document.querySelector(`.${styles.popUpContainer}`);
    console.log(e.target.className);
    if (openPopUp === false || e.target.className !== styles.popUpContainer) {
      popUpContainer.style.display = "flex";
    } else {
      // popUp.style.top = "-100vh";
      popUpContainer.style.display = "none";
    }
    setOpenPopUp(!openPopUp);
  };

  const [openSideBar, setOpenSideBar] = useState(false);
  const toggleSideBar = () => {
    console.log(openSideBar);
    if (!openSideBar) {
      navItemContainer.current.style.display = "flex";
      setTimeout(() => {
        navItemContainer.current.style.height = "150vh";
        navItemContainer.current.style.width = "100vw";
      }, 0);
    } else {
      setTimeout(() => {
        navItemContainer.current.style.height = "0";
        navItemContainer.current.style.width = "0";
      }, 0);
      setTimeout(() => {
        navItemContainer.current.style.display = "none";
      }, 1000);
    }
    setOpenSideBar(!openSideBar);
  };

  return (
    <>
      <div className={styles.headerInfo}>
        Are you thrilled to join us on this journey? Our product is on the verge
        of going live.{" "}
        <span
          onClick={() => {
            navigate("/corporate");
          }}
        >
          Reach out{" "}
        </span>
        to us for further details!
      </div>
      <div className={styles.Navbar}>
        <div className={styles.companyName}>
          <img
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
            src={images.logo}
            alt=""
          />
        </div>
        <div style={{ position: "relative", width: "100%" }}>
          <div className={styles.HamburgerMenu}>
            <img
              className={styles.HamburgerMenuImg}
              onClick={() => toggleSideBar()}
              src={images.HamburgerMenu}
              alt="HamburgerMenu"
            />
          </div>
          <div className={styles.navItemContainer} ref={navItemContainer}>
            <div className={styles.crossIcon}>
              <img
                onClick={() => toggleSideBar()}
                src={images.crossIcon}
                alt="crossIcon"
              />
            </div>
            <div className={styles.navItems}>
              <li onClick={(e) => activeLink(e)}>
                <Link
                  ref={(elem) => (linkRef.current[0] = elem)}
                  to="/landlord"
                >
                  Landlord
                </Link>
              </li>
              <li onClick={(e) => activeLink(e)}>
                <Link ref={(elem) => (linkRef.current[1] = elem)} to="/tenant">
                  Tenant
                </Link>
              </li>
              <li onClick={(e) => activeLink(e)}>
                <Link
                  ref={(elem) => (linkRef.current[2] = elem)}
                  to="/individual"
                >
                  Individual
                </Link>
              </li>
              <li onClick={(e) => activeLink(e)}>
                <Link
                  ref={(elem) => (linkRef.current[3] = elem)}
                  to="/community"
                >
                  Community
                </Link>
              </li>
            </div>
            <div className={styles.button}>
              <Button text={"Login / Sign In"} path="/login" />
            </div>
            <div
              className={styles.mobileScreenButton}
              onClick={(e) => toggelPopUp(e)}
            >
              <Button text={"Login / Sign In"} path="" />
              <div
                className={styles.popUpContainer}
                onClick={(e) => toggelPopUp(e)}
              >
                <div className={styles.popUp}>
                  {/* <div>
                <img
                  src={images.crossIcon}
                  alt="cross_icon"
                  onClick={toggelPopUp}
                />
              </div> */}
                  <div className={styles.info}>
                    Open the website on the Desktop to login the portal.
                  </div>
                  <div className={styles["download-btn-container"]}>
                    <DownloadButton
                      text="Download on App Store"
                      icon={images.Apple}
                    />
                    <DownloadButton
                      text="Download on Google Play"
                      icon={images.PlayStore}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
